import { type FC } from 'react';

import RouteFilters from '@/components/routes/route-filters';
import SearchInput from '@/components/shared/search-input';
import useRouteSearch from '@/hooks/use-route-search';
import { ROUTE_LIST } from '@/utils/constants';

const RouteListStickyContent: FC = () => {
  const { activeSearchKey, setActiveSearchKey } = useRouteSearch(ROUTE_LIST);

  return (
    <div className="flex flex-col gap-4">
      <SearchInput onChange={setActiveSearchKey} initialValue={activeSearchKey} />
      <RouteFilters />
    </div>
  );
};

export default RouteListStickyContent;
